export default {
      id: "ratio-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#ratio",
      toString: function () {
        return this.url;
      }
    }